import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { fetchFreeHubsForUser } from '../../../api/api_users';

const LinkHubFast = () => {
    const { translations } = useLanguage();
    const navigate = useNavigate();
    const [linkedDevices, setLinkedDevices] = useState({ data: [] });

    useEffect(() => {
        const loadLinkedDevices = async () => {
            try {
                const devices = await fetchFreeHubsForUser();
                if (devices.data && Array.isArray(devices.data)) {
                    setLinkedDevices({ data: devices.data });
                } else {
                    setLinkedDevices({ data: [] });
                }
            } catch (error) {
                console.error('Failed to fetch devices:', error);
                setLinkedDevices({ data: [] });
            }
        };
        loadLinkedDevices();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAddHub = async (hub) => {
        navigate('configure', { state: { hub: hub } });
    };

    return (
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.new_device}</h1>
                </div>
                <div className="content2">
                    <div className="sm-space-info2 centered-space-info">
                        <h2>{translations.linked_devices_list}</h2>
                        {linkedDevices.data.map((device, index) => (
                            <div key={index} className="content2">
                                <div className="general-button secondary-button" onClick={() => handleAddHub(device)}>
                                    {device.name}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkHubFast;
